export const EMPTY_VOUCHER = { code: '', discount_type: 'fixed_amount', discount_value: '', maximum_discount_value: '', expiration_date: '', minimum_transaction_value: '', max_redemption_per_user: 1, active: true, is_promoted: false, promotional_text: '', custom_product_filter: '' }
export const wibDateTime = (value) => {
  if (!value) return ''
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? '' : new Date(date.getTime() + 7 * 3600000).toISOString().slice(0, 19)
}
export const formValues = (record) => ({ ...EMPTY_VOUCHER, ...Object.fromEntries(Object.keys(EMPTY_VOUCHER).map((key) => [key, record[key] == null ? '' : record[key]])), expiration_date: wibDateTime(record.expiration_date) })
export const voucherPayload = (values) => ({ ...Object.fromEntries(Object.keys(EMPTY_VOUCHER).map((key) => [key, values[key]])), expiration_date: values.expiration_date ? `${values.expiration_date}+07:00` : '' })
export const datePreset = (period, now = new Date()) => {
  const today = wibDateTime(now).slice(0, 10)
  const date = new Date(`${today}T00:00:00Z`)
  if (period === 'week') date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 6) % 7)
  if (period === 'month') date.setUTCDate(1)
  if (period === 'year') { date.setUTCMonth(0); date.setUTCDate(1) }
  return { from: date.toISOString().slice(0, 10), to: today }
}
export const formatAmount = (value) => String(value ?? '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
